
import { Validator } from 'formstate';
import { isValidPhoneNumber } from 'react-phone-number-input';

export function containsValidCharacters(messageKey?: string) {
  return (value: string) => {
    return value && value.includes('_') && (messageKey || 'does not match international format');
  };
}

export function phoneNumberValidator(messageKey?: string): Validator<string> {
  return (value: string) => {
    if (!value) return null; // Let "required" validator handle empty 
    return isValidPhoneNumber(value) ? null : (messageKey || 'does not match international format');
  };
}
